export type UrlPair = { real: string; mock: string };

export type MockUrlReplacer = {
  isMock: (url: string) => boolean;
  isMockable: (url: string) => boolean;
  realToMock: (url: string) => string;
  mockToReal: (url: string) => string;
};

export const makeMockUrlReplacer = (pairs: UrlPair[]): MockUrlReplacer => {
  const isMockable = (url: string) => pairs.some((pair) => url.includes(pair.real));
  const isMock = (url: string) => pairs.some((pair) => url.includes(pair.mock));

  const realToMock = (url: string) => {
    const urlLowerCase = url.toLowerCase();
    const replacement = pairs.find((pair) => urlLowerCase.includes(pair.real));
    if (!replacement) {
      return urlLowerCase;
    }

    return urlLowerCase.replace(replacement.real, replacement.mock);
  };

  const mockToReal = (url: string) => {
    const urlLowerCase = url.toLowerCase();
    const replacement = pairs.find((pair) => urlLowerCase.includes(pair.mock));
    if (!replacement) {
      return urlLowerCase;
    }

    return urlLowerCase.replace(replacement.mock, replacement.real);
  };

  return { isMock, isMockable, realToMock, mockToReal };
};

const removeWWWGlobal = (url: string) => url.replace(/www\./, '');
const s3Url = 'https://sales-workspace-staging.s3.us-east-1.amazonaws.com/extension/';

const replacementPairs: UrlPair[] = [
  'https://www.linkedin.com',
  'https://calendar.google.com',
  'https://app-eu1.hubspot.com',
  'https://org9b404ab4.crm4.dynamics.com',
].map((url) => ({
  real: url,
  mock: removeWWWGlobal(url).replace('https://', s3Url),
}));

export const mockUrlReplacer = makeMockUrlReplacer(replacementPairs);
